import { Translation } from '@shared/types/translation';

export const SERVICE_MANAGEMENT_ERROR_MESSAGES = {
  // Fixed lead phrase for the already-in-status error — the actual status
  // name (e.g. "Ukończone") is appended after this at render time.
  ALREADY_STATUS_TEMPLATE: {
    english: 'Service request is already',
    polish: 'Zgłoszenie serwisowe ma już status',
  },
  MISSED_VISIT_OTHER_REASON_REQUIRED: {
    english: 'Please Specify Reason',
    polish: 'Podaj powód',
  },
} as const satisfies Record<string, Translation>;
